const kashika2Options = [
    {
        menuName: "水害リスク情報（河川）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label : "河川浸水想定区域図\n（計画規模）",
                type: "vector",
                dataset_id: 0,
                id: "kasen",
                url:process.env.REACT_APP_KASEN,
                layerName:"64_1_shinsui_keikakukibo",
                color:"#DC2626",
                opacity: 0.7
            },
            {
                label : "河川浸水想定区域図\n（想定最大規模）",
                type: "vector",
                dataset_id: 1,
                id: "kasen-saidai",
                url:process.env.REACT_APP_LAYER_64_2_KASEN_SHINSUI_MAX,
                layerName:"64_2_shinsui_souteisaidai",
                color:"orangered",
                opacity: 0.7
            },
            {
                label : "河川浸水継続時間\n（想定最大規模）",
                type: "vector",
                dataset_id: 2,
                id: "kasen-keizoku",
                url:process.env.REACT_APP_LAYER_64_3_KASEN_SHINSUI_TIME,
                layerName:"64_3_shinsui_keizokuzikan",
                color:"tomato",
                opacity: 0.7
            },
        ]
    },
    {
        menuName: "水害リスク情報（高潮・津波）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "高潮浸水想定図\n（30年確率）",
                type: "vector",
                dataset_id: 4,
                id: "takashio",
                url:process.env.REACT_APP_TAKASHIO,
                layerName:"70_1_takashio_30year",
                color:"#65A30D",
                opacity: 0.7
            },
            {
                label: "高潮浸水想定図\n（伊勢湾台風規模）",
                type: "vector",
                dataset_id: 5,
                id: "takashio-isewan",
                url:process.env.REACT_APP_LAYER_70_2_TAKASHIO_ISE,
                layerName:"70_2_takashio_isewan",
                color:"#EA580C",
                opacity: 0.7
            },
            {
                label: "高潮浸水想定図\n（想定最大規模）",
                type: "vector",
                dataset_id: 6,
                id: "takashio-saidai",
                url:process.env.REACT_APP_LAYER_70_3_TAKASHIO_KEIKAKU,
                layerName:"70_3_takashio_max",
                color:"steelblue",
                opacity: 0.7
            },
            {
                label: "津波浸水想定図",
                type: "vector",
                dataset_id: 7,
                id: "tsunami",
                url:process.env.REACT_APP_TSUNAMI,
                layerName:"71_tsusnami_shinsui",
                color:"cyan",
                opacity: 0.7
            },
            {
                label: "津波災害警戒区域図",
                type: "vector",
                dataset_id: 8,
                id: "tsunami-saigai",
                url:process.env.REACT_APP_TSUNAMI_SAIGAI,
                layerName:"72_tsunami_keikai",
                color:"#ffffb3",
                opacity: 0.7,
                legendColorClass: "h-tsunami-saigai",
            },
        ]
    },
    {
        menuName: "土砂災害リスク情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "土砂災害警戒区域_土石流",
                type: "vector",
                dataset_id: 9,
                id: "tosha_73_1",
                url:process.env.REACT_APP_LAYER_73_1,
                layerName: "73_dosekiryu_keikai",
                color:"#fffe9b",
                borderColor:"#1072bd",
                border: '1px solid blue',
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-dosekiryu"
            },
            {
                label: "土砂災害警戒区域_地すべり",
                type: "vector",
                dataset_id: 11,
                id: "tosha_73_3",
                url:process.env.REACT_APP_LAYER_73_3,
                layerName: "73_jisuberi_keikai",
                color:"#fffe9b",
                borderColor:"#eb7d3c",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-jisuberi"
            },
            {
                label: "土砂災害警戒区域_がけ崩れ",
                type: "vector",
                dataset_id: 12,
                id: "tosha_73_4",
                url:process.env.REACT_APP_LAYER_73_4,
                layerName: "73_kyukeisya_keikai",
                color:"#fffe9b",
                borderColor:"#72ac4d",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-gake"
            },
            {
                label: "土砂災害特別警戒区域_土石流",
                type: "vector",
                dataset_id: 10,
                id: "tosha_73_2",
                url:process.env.REACT_APP_LAYER_73_2,
                layerName: "73_dosekiryu_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc0d1b",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-dosekiryu"
            },
            {
                label: "土砂災害特別警戒区域_がけ崩れ",
                type: "vector",
                dataset_id: 13,
                id: "73_kyukeisya_tokubetsukeikai",
                url:process.env.REACT_APP_LAYER_73_5,
                layerName: "73_kyukeisya_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc3dca",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-gake"
            },

            {
                label: "砂防指定地_土石流",
                type: "vector",
                dataset_id: 17,
                id: "77_1_sabo",
                url:process.env.REACT_APP_LAYER_77_1_SABOU,
                layerName: "77_1_sabo",
                color:"#f5be9d",
                borderColor:"#1072bd",
                opacity: 0.7,
                legendColorClass: "h-dosha-ss-dosekiryu"
            },
            {
                label: "地すべり防止区域_地すべり",
                type: "vector",
                dataset_id: 17,
                id: "77_3_jisuberi",
                url:process.env.REACT_APP_LAYER_77_3_SABOU,
                layerName: "77_3_jisuberi",
                color:"#f5be9d",
                borderColor:"#eb7d3c",
                opacity: 0.7,
                legendColorClass: "h-dosha-jb-jisuberi"
            },
            {
                label: "急傾斜地崩壊危険区域_がけ崩れ",
                type: "marker",
                dataset_id: 17,
                id: "77_2_kyukeisha",
                url:process.env.REACT_APP_LAYER_77_2_SABOU,
                // color:"orange",
                opacity: 0.7
            },
          
            {
                label: "雪崩危険箇所_雪崩",
                type: "vector",
                dataset_id: 15,
                id: "nadare",
                url:process.env.REACT_APP_NADARE,
                layerName:"74_nadare",
                color:"#b8d5a6",
                borderColor:"#1db1ed",
                opacity: 0.7,
                legendColorClass: "h-dosha-nadare"
            },
        ]
    },
  
    // {
    //     menuName: "土砂災害危険度情報",
    //     activateAccordion: false,
    //     useAccordion: true,
    //     options: [
    //
    //         {
    //             // # 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
    //             label: "土砂災害危険度_1kmメッシュ",
    //             type: "vector",
    //             id: "vis_63_1",
    //             url:process.env.REACT_APP_63_1_TILE,
    //             dataUrl:process.env.REACT_APP_63_1_DATA,
    //             layerName:"mesh_1km",
    //         },
    //     ]
    // },
  
    // {
    //     menuName: "地震リスク情報",
    //     activateAccordion: false,
    //     useAccordion: true,
    //     options : [
    //         {
    //             // 91: 地震被害想定図
    //             label: "地震被害想定図",
    //             type: "vector",
    //             id: "vis_91",
    //             url:process.env.REACT_APP_LAYER_91,
    //             layerName:"earthquake_nankai",
    //         },
    //     ]
    // },
    
    {
        menuName: "ため池情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ため池ポイント",
                type: "marker",
                dataset_id: 20,
                id: "tameike",
                url:process.env.REACT_APP_TAMEIKE
            },
            {
                label: "ため池浸水想定区域",
                type: "vector",
                dataset_id: 21,
                id: "shinsui",
                url:process.env.REACT_APP_LAYER_80_TAMEIKE_SHINSUI,
                layerName:"80_tameike_shinsui",
                color:"#6373e6",
                opacity: 0.7,
                legendColorClass: "h-tameike"
            },
        ]
    },
    {
        menuName: "避難所情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "避難所情報",
                type: "marker",
                dataset_id: 3,
                id: "hinanjo",
                url:process.env.REACT_APP_HINANJO
            },
        ]
    },

    {
        menuName: "過去に発生した災害の記録",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "災害の記録",
                type: "marker",
                id: "vis_66",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_SPOT_66,
            },
        ]
    },

    {
        menuName: "観測情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
          
            {
                // # 32: 河川管理情報システム 雨量日集計
                label: "雨量",
                type: "marker",
                id: "vis_32",
                url:process.env.REACT_APP_SPOT_32,
            },

            {
                // # 34: 河川管理情報システム 観測情報　水位日集計
                label: "水位",
                type: "marker",
                id: "vis_34",
                url:process.env.REACT_APP_SPOT_34,
            },

            {
                // # 36: 河川管理情報システム 観測情報　ダム日集計
                label: "ダム諸量",
                type: "marker",
                id: "vis_36",
                url:process.env.REACT_APP_SPOT_36,
            },

            {
                // # 39: 河川管理情報システム 観測情報　風向風速日集計
                label: "風向風速",
                type: "marker",
                id: "vis_39",
                url:process.env.REACT_APP_SPOT_39,
            },

            {
                // # 38: 河川管理情報システム 観測情報　潮位日集計
                label: "潮位",
                type: "marker",
                id: "vis_38",
                url:process.env.REACT_APP_SPOT_38,
            },

            {
                // # ため池 観測情報
                // コンポーネントは MenuSpot
                label: "ため池",
                type: "marker",
                id: "vis_103",
                column_lat: "緯度",
                column_lng: "経度",
            },
        ]
    },
  
    {
        menuName: "道路に関する情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "本日の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_1",
                url:process.env.REACT_APP_DOROKISEI_1
            },
            {
                label: "今後の規制",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_2",
                url:process.env.REACT_APP_DOROKISEI_2
            },
            {
                label: "事前通行規制区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_3",
                url:process.env.REACT_APP_DOROKISEI_3
            },
            {
                label: "走行注意区間",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_4",
                url:process.env.REACT_APP_DOROKISEI_4
            },
            {
                label: "緊急輸送道路",
                type: "marker",
                dataset_id: 3,
                id: "dorokisei_5",
                url:process.env.REACT_APP_DOROKISEI_5
            },  
            {
                label: "道路カメラ・冬季道路情報",
                type: "marker",
                dataset_id: 3,
                id: "sekisetusin_6_10",
                url:process.env.REACT_APP_SEKISETUSIN_6_10
            },
            {
                label: "道路台帳附図",
                type: "marker",
                id: "vis_92",
                url:process.env.REACT_APP_SPOT_92
            },
        ]
    },

    {
        menuName: "航路に関する情報",
        activateAccordion: false,
        useAccordion: true,
        options: [

            {
                // 89: # 89: 瀬戸内海島しょ部	航路データ
                label: "航路",
                type: "marker",
                id: "vis_89",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_SPOT_89,
            },
        ]
    },

    {
        menuName: "ボーリングデータ",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ボーリングデータ",
                type: "marker",
                dataset_id: 27,
                id: "boring",
                url:process.env.REACT_APP_LAYER_83_BORING,
                color:"",
                opacity: 0.7
            }
        ]
    },

    {
        menuName: "都市計画基礎調査データ",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "行政区域",
                type: "vector",
                dataset_id: 29,
                id: "toshi_85_1_1",
                url:process.env.REACT_APP_LAYER_85_1_1_CITY,
                layerName:"85_1_1_gyosei",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#000000",
                legendColorClass: "h-toshi-gyousei"
                // 行政区域だけ点線設定をVectorGrid.jsxで行っているので注意
            },
            {
                label: "都市計画区域",
                type: "vector",
                dataset_id: 30,
                id: "toshi_85_1_2",
                url:process.env.REACT_APP_LAYER_85_1_2_CITY,
                layerName:"85_1_2_toshikeikaku",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#969696",
                legendColorClass: "h-toshi-keikaku"
            },
            {
                label: "市街化区域",
                type: "vector",
                dataset_id: 32,
                id: "toshi_85_1_4",
                url:process.env.REACT_APP_LAYER_85_1_4_CITY,
                layerName:"85_1_4_shigaika",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#ff3232",
                legendColorClass: "h-toshi-shigaika-kuiki"
            },
            {
                label: "市街化調整区域",
                type: "vector",
                dataset_id: 33,
                id: "toshi_85_1_5",
                url:process.env.REACT_APP_LAYER_85_1_5_CITY,
                layerName:"85_1_5_shigaika_chosei",
                color:"#ffbeb4",
                opacity: 0.7,
                borderColor: "#ffbeb4",
                legendColorClass: "h-toshi-shigaika-chousei"
            },
            {
                label: "非線引き用途地域",
                type: "vector",
                dataset_id: 34,
                id: "toshi_85_1_6",
                url:process.env.REACT_APP_LAYER_85_1_6_CITY,
                layerName:"85_1_6_hisenbiki",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#ff5500",
                legendColorClass: "h-toshi-h-tiiki"
            },
            {
                label: "非線引き用途白地",
                type: "vector",
                dataset_id: 35,
                id: "toshi_85_1_7",
                url:process.env.REACT_APP_LAYER_85_1_7_CITY,
                layerName:"85_1_7_hisenbiki_haku",
                color:"#bee6ff",
                opacity: 0.7,
                borderColor: "#bee6ff",
                legendColorClass: "h-toshi-h-hakuchi"
            },
            // {
            //     label: "準都市計画区域",
            //     type: "vector",
            //     dataset_id: 35,
            //     id: "85_1_8",
            //     url:process.env.REACT_APP_LAYER_85_1_7_CITY,
            //     layerName:"85_1_7_hisenbiki_haku",
            //     color:"transparent",
            //     opacity: 0.7,
            //     borderColor: "#287300",
            //     legendColorClass: "h-toshi-jyun"
            // },
            // {
            //     label: "準都市計画区域用途地域",
            //     type: "vector",
            //     dataset_id: 35,
            //     id: "85_1_9",
            //     url:process.env.REACT_APP_LAYER_85_1_7_CITY,
            //     layerName:"85_1_7_hisenbiki_haku",
            //     color:"transparent",
            //     opacity: 0.7,
            //     borderColor: "#ff5500",
            //     legendColorClass: "h-toshi-jyun-tiiki"
            // },
            // {
            //     label: "準都市計画区域用途白地",
            //     type: "vector",
            //     dataset_id: 35,
            //     id: "85_1_10",
            //     url:process.env.REACT_APP_LAYER_85_1_7_CITY,
            //     layerName:"85_1_7_hisenbiki_haku",
            //     color:"#e6e600",
            //     opacity: 0.7,
            //     borderColor: "#e6e600",
            //     legendColorClass: "h-toshi-jyun-hakuchi"
            // },
            {
                label: "各種用途地域",
                type: "vector",
                dataset_id: 39,
                id: "toshi_85_1_11",
                url:process.env.REACT_APP_LAYER_85_1_11_CITY,
                layerName:"85_1_11_kakushu_youto",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "居住誘導区域",
                type: "vector",
                dataset_id: 40,
                id: "toshi_85_1_12",
                url:process.env.REACT_APP_LAYER_85_1_12_CITY,
                layerName:"85_1_12_kyojuu_yuudou",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#aa00e6",
                legendColorClass: "h-toshi-kyojyuu"
            },
            {
                label: "都市機能誘導区域",
                type: "vector",
                dataset_id: 41,
                id: "toshi_85_1_13",
                url:process.env.REACT_APP_LAYER_85_1_13_CITY,
                layerName:"85_1_13_toshikinouyuudou",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#4be600",
                legendColorClass: "h-toshi-kinou"
            },
            {
                label: "土地利用現況 250ｍメッシュ単位",
                type: "vector",
                dataset_id: 41,
                id: "85_2_1_land_250m",
                url:process.env.REACT_APP_LAYER_85_2_1_LAND_250M,
                layerName:"85_2_1_land_250m",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "土地利用現況 町丁目単位",
                type: "vector",
                dataset_id: 41,
                id: "85_2_2_land_town",
                url:process.env.REACT_APP_LAYER_85_2_2_LAND_TOWN,
                layerName:"85_2_2_land_town",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },

            {
                label: "土地利用現況 敷地毎",
                type: "vector",
                dataset_id: 41,
                id: "85_2_3_land_site",
                url:process.env.REACT_APP_LAYER_85_2_3_LAND_SITE,
                layerName:"85_2_3_land_site",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
          
            {
                label: "建物利用現況 250ｍメッシュ単位",
                type: "vector",
                id: "85_3_1_building_250m",
                url:process.env.REACT_APP_LAYER_85_3_1_BUILDING_250M,
                layerName:"85_3_1_building_250m",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },

            {
                label: "建物利用現況 町丁目単位",
                type: "vector",
                dataset_id: 41,
                id: "85_3_2_building_town",
                url:process.env.REACT_APP_LAYER_85_3_2_BUILDING_TOWN,
                layerName:"85_3_2_building_town",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },

            {
                label: "建物利用現況 建物毎",
                type: "vector",
                dataset_id: 41,
                id: "85_3_3_building_building",
                url:process.env.REACT_APP_LAYER_85_3_3_BUILDING_BUILDING,
                layerName:"85_3_3_building_building",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },

            {
                label: "人口 500mメッシュ",
                type: "vector",
                id: "85_4_1_population_500m",
                url:process.env.REACT_APP_LAYER_85_4_1_POPULATION_500M,
                layerName:"85_4_1_population_500m",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "人口 町丁目",
                type: "vector",
                id: "85_4_2_population_town",
                url:process.env.REACT_APP_LAYER_85_4_2_POPULATION_TOWN,
                layerName:"85_4_2_population_town",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "DID地区境界データ",
                type: "vector",
                id: "85_5_did",
                url:process.env.REACT_APP_LAYER_85_5_DID,
                layerName:"85_5_did",
                color:"transparent",
                opacity: 0.7,
                borderColor: "#3232aa",
                legendColorClass: "h-toshi-did-tiku-kyoukai"
            },
        ]
    },


    {
        menuName: "インフラ情報（道路）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "橋梁",
                type: "marker",
                dataset_id: 22,
                id: "kyoryo",
                url:process.env.REACT_APP_SPOT_14_KYORYO
            },
            {
                label: "横断歩道橋",
                type: "marker",
                dataset_id: 22,
                id: "hodokyo",
                url:process.env.REACT_APP_SPOT_14_HODOKYO
            },
            {
                label: "トンネル",
                type: "marker",
                dataset_id: 23,
                id: "tunnel",
                url:process.env.REACT_APP_SPOT_15_TUNNEL
            },
            {
                label: "門型標識",
                type: "marker",
                dataset_id: 25,
                id: "doro-mongata",
                url:process.env.REACT_APP_SPOT_16_2_ROAD
            },
            {
                label: "シェッド",
                type: "marker",
                dataset_id: 24,
                id: "doro-shed",
                url:process.env.REACT_APP_SPOT_16_1_ROAD
            },
        ]
    },


    {
        menuName: "インフラ情報（河川）",
        activateAccordion: false,
        useAccordion: true,
        options: [

            {
                // # 22: 河川管理情報システム（河川AMS）	排水機場管理（河川）_詳細情報
                label: "排水機場（河川）",
                type: "marker",
                id: "vis_22",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_22,
            },

            {
                // # 19: 河川管理情報システム（河川AMS）	河川トンネル管理_詳細情報 マーカーは(上流端の座標を使用)
                label: "河川トンネル",
                type: "marker",
                id: "vis_19",
                column_lat: "上流端　緯度(10進数)",
                column_lng: "上流端　経度(10進数)",
                url:process.env.REACT_APP_SPOT_19,
            },

            {
                // # 21: 河川管理情報システム（河川AMS）	調節池管理_詳細情報
                label: "調整池",
                type: "marker",
                id: "vis_21",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_21,
            },

            {
                // # 20: 河川管理情報システム（河川AMS）	地下調節池管理_詳細情報
                label: "地下調整池",
                type: "marker",
                id: "vis_20",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_20,
            },

        ]},

  
    {
        menuName: "インフラ情報（ダム）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ダム",
                type: "marker",
                dataset_id: 26,
                id: "damu",
                url:process.env.REACT_APP_SPOT_24_DAM
            },
        ]
    },
  
  
    {
        menuName: "インフラ情報（砂防）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "砂防堰堤",
                type: "marker",
                dataset_id: 3,
                id: "sabo_25",
                url:process.env.REACT_APP_SABO_25
            },

            {
                // 78_2 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　砂防設備台帳_渓流保全工ライン
                label: "渓流保全工",
                type: "vector",
                id: "vis_78_2",
                color:"#06ACFF",
                borderColor: "#06ACFF",
                layerName:"78_051shp_keiryu_line",
                legendColorClass: "h-dosha-dskid-keiryuhozen",
                url:process.env.REACT_APP_LAYER_78_2,
            },
            {
                // 78_3 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　急傾斜地崩壊対策施設
                label: "急傾斜地崩壊防止施設",
                type: "marker",
                id: "vis_78_3",
                menuIcon: true,
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_LAYER_78_3,
            },
            {
                // 78_4 広島県砂防GIS管理システム	GIS情報	砂防設備・急傾斜地崩壊対策施設　地すべり対策施設
                label: "地すべり防止施設",
                type: "vector",
                id: "vis_78_4",
                color:"#CDCD66",
                borderColor: "#6D6D00",
                layerName:"78_053_jisuberi_shisetsu",
                legendColorClass: "h-dosha-jb-jisuberi-shisetsu",
                url:process.env.REACT_APP_LAYER_78_4,
            },
        ]
    },
  
    {
        menuName: "インフラ情報（港湾・漁港）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "外郭施設（港湾）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_1",
                url:process.env.REACT_APP_KOUWAN_30_1
            },
            {
                label: "係留施設（港湾）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_2",
                url:process.env.REACT_APP_KOUWAN_30_2
            },
            {
                label: "臨港交通施設（港湾）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_3",
                url:process.env.REACT_APP_KOUWAN_30_3
            },
            {
                label: "外郭施設（漁港）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_5",
                url:process.env.REACT_APP_KOUWAN_30_5
            },
            {
                label: "係留施設（漁港）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_6",
                url:process.env.REACT_APP_KOUWAN_30_6
            },
            {
                label: "臨港交通施設（漁港）",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_7",
                url:process.env.REACT_APP_KOUWAN_30_7
            },
        ]
    },
    {
        menuName: "インフラ情報（海岸）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "防潮扉（水門・陸閘）",
                type: "marker",
                dataset_id: 3,
                id: "suimon_29",
                url:process.env.REACT_APP_SUIMON_29
            },
            {
                label: "海岸保全施設",
                type: "marker",
                dataset_id: 3,
                id: "kouwan_30_4",
                url:process.env.REACT_APP_KOUWAN_30_4
            },
            {
                // # 18: 河川管理情報システム（河川AMS）	排水機場管理（港湾）_詳細情報
                label: "排水機場（港湾海岸）",
                type: "marker",
                id: "vis_18",
                column_lat: "緯度(10進数)",
                column_lng: "経度(10進数)",
                url:process.env.REACT_APP_SPOT_18,
            },

        ]
    },

    {
        menuId: "menu_97",
        menuName: "インフラ情報（下水道）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "管渠（汚水）",
                type: "vector",
                id: "vis_97_1",
                color:"#1f4bba",
                borderColor: "#1f4bba",
                layerName:"97_1_kankyo",
                legendColorClass: "h-kasenho-1",
                url:process.env.REACT_APP_LAYER_97_1,
            },
            {
                label: "取付管（汚水）",
                type: "vector",
                id: "vis_97_2",
                color:"#2399eb",
                borderColor: "#2399eb",
                layerName:"97_2_toritsukekan",
                legendColorClass: "h-kasenho-2",
                url:process.env.REACT_APP_LAYER_97_2,
            },
            {
                label: "鞘管（汚水）",
                type: "vector",
                id: "vis_97_3",
                color:"#996bd3",
                borderColor: "#996bd3",
                layerName:"97_3_sayakan",
                legendColorClass: "h-97_3",
                url:process.env.REACT_APP_LAYER_97_3,
            },
            {
                label: "人孔（汚水）",
                type: "vector",
                id: "vis_97_4",
                color:"#e3440a",
                borderColor: "#e3440a",
                layerName:"97_4_jinko",
                legendColorClass: "h-97_4",
                url:process.env.REACT_APP_LAYER_97_4,
            },
        ]
    },


    {
        menuId: "menu_99",
        menuName: "インフラ情報（流域下水道）",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ポンプ場",
                type: "marker",
                id: "vis_99_1",
                column_lat: "緯度",
                column_lng: "経度",
            },
            {
                label: "浄化センター",
                type: "marker",
                id: "vis_99_4",
                column_lat: "緯度",
                column_lng: "経度",
            },
            {
                label: "マンホール",
                type: "marker",
                id: "vis_99_2",
                column_lat: "緯度",
                column_lng: "経度",
            },
            {
                label: "管渠",
                type: "vector",
                id: "vis_99_3",
                color:"#ff0000",
                borderColor: "#ff0000",
                layerName:"99_3_kankyo",
                legendColorClass: "h-road-i-soukou-01",
                url:process.env.REACT_APP_LAYER_99_3,
            }
        ]
    },


    {
        menuName: "非常用電話位置情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "非常用電話位置情報",
                type: "marker",
                id: "vis_95",
                column_lat: "緯度　世界",
                column_lng: "経度　世界",
                url:process.env.REACT_APP_SPOT_95
            },
        ]
    },

    {
        menuName: "林業経営適地",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "林業経営適地",
                type: "vector",
                id: "vis_104",
                layerName: "104_ringyo_tekichi",
                color:"#229470",
                legendColorClass: "h-hou-shizen",
                url:process.env.REACT_APP_LAYER_104
            },
        ]
    },
];

export  {
    kashika2Options
};
